import { render } from "./CrTextarea.vue?vue&type=template&id=95cffcda&scoped=true"
import script from "./CrTextarea.vue?vue&type=script&lang=js"
export * from "./CrTextarea.vue?vue&type=script&lang=js"

import "./CrTextarea.vue?vue&type=style&index=0&id=95cffcda&scoped=true&lang=scss"

import exportComponent from "/home/forge/pga-beta.devserver6.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95cffcda"]])

export default __exports__